export default __webpack_public_path__ + "static/media/ISFGS-SurgeonPlaceholder.33be440a.png";